export enum ComponentId {
  PERPETRATOR_GENERAL_WAS_DRIVER_PERPETRATOR = "wasDriverPerpetrator",
  PERPETRATOR_GENERAL_WAS_DRIVER_SOBER = "wasDriverSober",
  PERPETRATOR_GENERAL_IS_KNOWN = "isKnown",
  PERPETRATOR_GENERAL_WAS_DRIVING = "wasDriving",
  PERPETRATOR_GENERAL_CAR_OWNER = "carOwner",
  PERPETRATOR_GENERAL_ID = "id",
}
